<div mat-dialog-title>
  <h1 class="titulo-simpli">Cambiar avatar</h1>
  <small class="subtitulo-simpli">Sube tu imagen preferida como avatar</small>
</div>

<mat-dialog-content>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <mat-form-field appearance="fill" (click)="change_avatar()">
        <mat-label>Subir nuevo avatar</mat-label>
        <input matInput readonly [value]="name_img">
        <mat-icon matSuffix class="icon-color">account_circle</mat-icon>
        <mat-hint>Selecciona una imagen</mat-hint>
      </mat-form-field>

      <input id="input-avatar" type="file" (change)="fileChangeEvent($event)" style="display: none;" />
    </div>

    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 col-top animate__animated animate__fadeIn"
      *ngIf="imageChangedEvent">
      <div style="text-align: center;">
        <small>Imagen Cargada</small>
      </div>
      <div class="cropper-container">
        <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="4 / 4" [resizeToWidth]="256" 
          format="png" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded($event)"
          (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()"></image-cropper>
      </div>
    </div>

    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 col-top animate__animated animate__fadeIn" *ngIf="croppedImage">
      <div style="text-align: center;">
        <small>Vista previa</small>
      </div>
      <img class="user_image" [src]="croppedImage" />
    </div>

  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-flat-button color="primary" class="secondary-button" mat-dialog-close>Cerrar</button>

  <button [disabled]="disabled" (click)="envia_form()" class="primary-button" mat-flat-button color="primary"
    type="button">
    <mat-label *ngIf="loading == false">Subir avatar</mat-label>
    <span *ngIf="loading == true">
      <i class="fa-solid fa-spinner fa-spin-pulse"></i>
    </span>
  </button>
</mat-dialog-actions>